import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import UserLocationDatePeriod from "../enums/UserLocationDatePeriod";

import getDateRangeForSelectedDatePeriod from "./getDateRangeForSelectedDatePeriod";

// The efficiency-chart / widgets range: Day and Week both show the week; Month
// shows the month. (Events use getDateRangeForSelectedDatePeriod directly.)
const getWidgetsDataDateRangeForSelection = (
  period: UserLocationDatePeriod,
  date: Date
): DateRange =>
  getDateRangeForSelectedDatePeriod(
    period === UserLocationDatePeriod.Month
      ? UserLocationDatePeriod.Month
      : UserLocationDatePeriod.Week,
    date
  );

export default getWidgetsDataDateRangeForSelection;
